import elementLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
  ...elementLocale,
  // 菜单
  menu: {
    home: '首页 Home Page',
    product: '产品介绍 Products',
    news: '新闻与资源 News',
    about: '关于我们 About Us',
    contact: '联系我们 Contact Us',
    case: '产品案例 Case Studies'
  },
  hero: {
    title: "广纳智能创新 丰盈永续未来",
    subtitle: "加速实现净零碳排，为各行业提供创新智能解决方案"
  },
  siteName: '广丰人工智能官网',
  siteDescription: '加速实现净零碳排，为各行业提供创新智能解决方案',
  home: {
    keywords: '智能科技产品, 广丰智能,广丰人工智能科技（山东）有限公司，重工业AI,智能化解决方案提供者' 
  }

}